<template>
  <div id="app">
    <Navbar ref="nav" v-show="show_nav" @set_active_nav="set_active_nav" />
    <StudentNavbar
      ref="student_nav"
      v-show="show_student_nav"
      @set_active_nav="set_active_nav"
    />
    <router-view
      @update_nav="update_nav"
      @hide_nav="hide_nav"
      @switch_nav="switch_nav"
      style="margin-top: 15px"
    />
    <!-- <div class="ui basic segment pushable" ref="to_push">
      <div class="ui inverted labeled icon top sidebar menu four item" style v-if="session_exists">
        <a class="item" v-on:click="go_home">
          <i class="home icon"></i>
          {{ $t("home") }}
        </a>
        <a class="item">
          <i class="block layout icon"></i>
          Topics
        </a>
        <a class="item" v-on:click="go_settings">
          <i class="settings icon"></i>
          {{ $t("settings") }}
        </a>
        <a class="item">
          <i class="calendar icon"></i>
          History
        </a>
      </div>
      <div class="pusher">
        <router-view />
      </div>
    </div>-->
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import StudentNavbar from "@/components/StudentNavbar";
// import Mumble from "mumble-js";

export default {
  data() {
    return {
      session_exists: this.$session.exists(),
      show_nav: false,
      show_student_nav: false,
    };
  },
  methods: {
    go_settings() {
      this.$router.replace({ name: "Settings" });
    },
    go_home() {
      this.$router.replace({ name: "Home" });
    },
    update_nav(user) {
      // console.log("updating nav", user);
      this.$refs.nav.update_nav(user);
    },
    hide_nav() {
      // console.log("hidding nav");
      this.show_nav = false;
    },
    switch_nav(mode) {
      // console.log("switching nav", mode);
      if (mode.type == "student") {
        this.show_nav = false;
        this.show_student_nav = true;
        this.$refs.student_nav.update_nav(mode.data);
      } else if (mode.type == "modul") {
        this.show_nav = true;
        this.show_student_nav = false;
        this.$refs.nav.update_nav(mode.data);
      }
    },
    set_active_nav(activeNav) {
      // console.log("setting active nav", activeNav);
      if (activeNav == "student") {
        this.show_nav = false;
        this.show_student_nav = true;
      } else if (activeNav == "modul") {
        this.show_nav = true;
        this.show_student_nav = false;
      }
    },
  },
  mounted() {
    window
      .jQuery(".sidebar")
      .sidebar({
        context: window.jQuery(this.$refs.to_push),
        dimPage: false,
      })
      .sidebar("attach events", ".system.menu .menu.item");

    // var mumble = new Mumble({
    //   language: "es-ES",
    //   debug: false, // set to true to get some detailed information about what's going on
    //   // define some commands using regex or a simple string for exact matching
    //   commands: [
    //     {
    //       name: "google",
    //       command: /^google (.+) por mi\s?(por favor)?$/,

    //       action: function(query, polite) {
    //         console.log(query, polite);
    //         if (polite) {
    //           // google the query
    //         } else {
    //           console.log(
    //             "I will google that for you but only if you say please"
    //           );
    //         }
    //       }
    //     }
    //   ],

    //   // define global callbacks (see docs for all)
    //   callbacks: {
    //     start: function(event) {
    //       console.log("Starting..", event);
    //     }

    //     // start, end, speech, recognizeMatch, etc
    //   }
    // });

    // mumble.start();
  },
  components: { Navbar, StudentNavbar },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.pushable.segment {
  margin-top: 1px !important;
}

.pusher {
  margin-top: 15px;
}

body {
  background-color: #fafafa !important;
}

/** Fix better looking of datatables pagination */
.dataTables_wrapper .row:last-child {
  padding-top: 0 !important;
}
.dataTables_wrapper .row.dt-table {
  padding-bottom: 0 !important;
}
</style>
